"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogoWrap = exports.GridRight = exports.GridLeft = exports.GridCenter = exports.GridBottom = exports.Content = exports.FarewellText = exports.AlertText = exports.ButtonModal = exports.Bottom = exports.Top = exports.DesktopLink = exports.DesktopOnly = exports.StyledDiv = exports.MobileLink = void 0;
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
exports.MobileLink = (0, app_1.styled)(app_1.Link) `
  display: none;
  font-size: 0.9375rem;
  @media ${app_1.mobile} {
    display: block;
  }
`;
exports.StyledDiv = app_1.styled.div `
  min-height: 43.75rem;
  ${(theme) => [theme.overlay, theme.flexCenter]};
`;
const desktopOnlyCss = (0, app_1.css) `
  @media ${app_1.mobile} {
    display: none;
  }
`;
exports.DesktopOnly = app_1.styled.div `
  ${desktopOnlyCss}
`;
exports.DesktopLink = (0, app_1.styled)(app_1.Link) `
  ${desktopOnlyCss}
`;
exports.Top = app_1.styled.div `
  display: flex;
  justify-content: space-between;
  position: absolute;
  inset: 3rem;
  bottom: unset;

  > span:first-of-type {
    justify-content: flex-start;
    text-align: left;
  }

  @media ${app_1.mobile} {
    inset: 1.5rem;
    bottom: unset;
  }
`;
exports.Bottom = (0, app_1.styled)(exports.Top) `
  inset: 3rem;
  top: unset;

  @media ${app_1.mobile} {
    inset: 1.5rem;
    top: unset;
    gap: 8rem;
  }
`;
exports.ButtonModal = (0, app_1.styled)(ui_1.Button) `
  min-width: 0;
  height: auto;
  p {
    white-space: break-spaces;
  }
  :hover {
    background-color: transparent;
  }
`;
exports.AlertText = (0, app_1.styled)(app_1.Text) `
  text-decoration: underline;
`;
exports.FarewellText = (0, app_1.styled)(app_1.Text) `
  margin-top: ${(theme) => theme.spacing.medium};
`;
exports.Content = app_1.styled.div `
  text-align: center;
`;
exports.GridBottom = (0, app_1.styled)(ui_1.Grid) `
  width: 100%;
`;
exports.GridCenter = app_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.GridLeft = (0, app_1.styled)(exports.GridCenter) `
  justify-content: flex-start;
`;
exports.GridRight = (0, app_1.styled)(exports.GridCenter) `
  justify-content: flex-end;
`;
exports.LogoWrap = app_1.styled.div `
  > svg {
    max-width: 90vw;
  }
`;
